import createSingle from "./create-single.js";
import getAll from "./get-all.js";
import deleteSingle from "./delete-single.js";
import updateSingle from "./update-single.js";
import regenerateKeys from "./regenerate-keys.js";
import getSingle from "./get-single.js";

export default {
	createSingle,
	getAll,
	deleteSingle,
	updateSingle,
	regenerateKeys,
	getSingle,
};
